import AddSharpIcon from "@mui/icons-material/AddSharp";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import { IconButton, Tooltip, Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useRef, useState } from "react";
import { usePersistentState, markNavigationPreserve, consumeNavigationPreserve, clearNamespace } from "../../hooks/persistence";
import { Dropdown, Form, Modal } from "react-bootstrap";
import { useHistory, useLocation, useParams } from "react-router";
import Swal from "sweetalert2";
import DeleteItemIcon from "../../assets/images/icons/DeleteItem.png";
import EditIcon from '../../assets/images/icons/EditIcon.svg';
import ExpandMore from '../../assets/images/icons/ExpandMore.svg';
import TrashIcon from "../../assets/images/icons/Trash_Black.svg";
import Constant from "../../Constant";
import "../../sass/responsive.scss";
import { CommonService } from "../../Service/CommonService";
import { SupportApiService } from "../../Service/SupportApiService";
import Spinner from "../Common/Spinner";
import StatusDropdown from "../Common/StatusDropdown";
import StatusFaqModal from "../Common/StatusFaqModal";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import "../Dynamic/SupportRequest.scss";
import SupportFaqPanel from "./SupportFaqPanel";
import { Label } from "recharts";
import { Content } from "react-bootstrap/lib/Tab";
import Select from "react-select";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { Service } from "../../Service/ApiService";
import { stat } from "fs";
import CloseIcon from "@mui/icons-material/Close";
import DataGridLoader from "../Common/DataGridLoader";

// First, define an interface for your state type
interface LocationState {
  data: string;  // or whatever type your data is
  companyId: string;
}

const SupportRequest: React.FC = () => {
  const history = useHistory();
  const state = history.location.state as LocationState;
  const [supportRequests, setSupportRequests] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const [services, setServices] = useState([]);
  const { id } = useParams<{ id: string }>();
  const [totalCount, setTotalCount] = useState(0);
  const cursorPosition = useRef<number | null>(null);
  const location = useLocation();
  const [showDropdown, setShowDropdown] = useState(false);
  const buttonRef = useRef<HTMLDivElement>(null);
  const divRef = useRef<HTMLDivElement>(null);
  const [viewFaq, setViewFaq] = useState(false);
  const [showStatusFaq, setShowStatusFaq] = useState(false);
  const handleCloseFaq = () => setViewFaq(false);
  const handleShowFaq = () => setViewFaq(true);
  const [isRejected, setIsRejected] = useState(false);
  const [isCancelled, setIsCancelled] = useState(false);
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [isSellRequestAccepted, setSellRequestAccepted] = useState(false);
  const serviceRequestUpdateStatus = useRef({
      customerServiceRequestId: "",
      reason: "",
      status: "",
      serviceName: "",
      requestNumber: "",
      dynamicFields: [],
      spendHourOnRequest: "",
      companyId: "",
      userId: "",
      fee: "",
      feeType: "",
      trackNumber: "",
      flow: "",
      assignedTo: "",
      sourceCompanyAcceptedByName: "",
      destinationCompanyAcceptedByName: ""
  });
  const [sellRequestFee, setSellRequestFee] = useState('');
  const [sellRequestFeeType, setSellRequestFeeType] = useState('');
  const [selectedWarehouseUser, setSelectedWarehouseUser] = useState<string>("");
  const [warehouseError, setWarehouseError] = useState('');
  const [feeError, setFeeError] = useState('');
  const [feeTypeError, setFeeTypeError] = useState('');
  const [spendHour, setSpendHour]  = useState("");
  const [reason,setReason] = useState(""); 
  const [isSellRequestFeeUpdated, setSellRequestFeeUpdated] = useState(false);
  const [isOwnershipTransferedAccepted, setOwnershipTransferedAccepted] = useState(false);
  const [isSourceCompanyAccepted, setSourceCompanyAccepted] = useState(false);
  const [isSourceCompanyRejected, setSourceCompanyRejected] = useState(false);
  const [isReopenConfirm, setIsReopenConfirm] = useState(false);
  const [filteredActiveInactiveCompaniesList, setFilteredActiveInactiveCompaniesList] = useState([]);
  const [receivingCompany, setReceivingCompany] = useState<string>("");
  const [selectedTransferCompany, setSelectedTransferCompany] = useState<string>("");
  const [transferCompanyError, setTransferCompanyError] = useState('');
  const [sortField, setSortField] = useState("CreatedModifiedDate"); // Default sort
  const [sortDirection, setSortDirection] = useState("desc"); // Default ascending
  const [isBeforeCancel, setIsBeforeCancel] = useState(false);
  const [isInTransit, setInTransit] = useState(false);
  const [isInWarehouse, setIsInWarehouse] = useState(false);
  const [warehouseUserList, setWarehouseUserList] = useState([]);  
  const [trackNumberValue, setTrackNumber] = useState<string>("");
  const [ownershipName, setOwnershipName] = useState<string>("");
  const [flowValue, setFlow] = useState<string>("");
  const [isAgreed, setIsAgreed] = useState(false);
  const [agreeError, setAgreeError] = useState("");
  const [trackNumberError, setTrackNumberError] = useState('');
  const [ownershipNameError, setOwnershipNameError] = useState('');
  const [flowError, setFlowError] = useState('');
  const selectedTransferCompanyRef = useRef('');
  const [destinationCompanyName,setDestinationCompanyName] = useState('');
  const [sourceCompanyName, setSourceCompanyName] = useState('');
  const [selectedCompanyRequest, setSelectedCompanyRequest] = useState('');

  // For Request Type Dropdown
  const [showReqType, setShowReqType] = useState(false);
  const dropdownRef = useRef(null);

  const handleSelect = (event, value) => {
    event.stopPropagation(); // stop parent click
    handleFilterChange({ target: { value } }, "requestType");
    setShowReqType(false); // ✅ close after selecting
  };

  // ✅ Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowReqType(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
// For Request Dropdown End

  // Toggle dropdown visibility
  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  }
  const filteredCompanyOptions = filteredActiveInactiveCompaniesList.map((company: any) => ({
      value: company.id,
      label: company.companyName,
  }));
  const isReceivingCompanyExist = filteredCompanyOptions.some(
    (option) => option.label.toLowerCase() === receivingCompany.toLowerCase()
  );

  // State to store calculated position
  // const [position, setPosition] = useState<{ top: number; left: number }>({
  //   top: 0,
  //   left: 0,
  // });

  // Function to calculate and update the position
  // const updatePosition = () => {
  //     if (!buttonRef.current) return;

  //     const rect = buttonRef.current.getBoundingClientRect();
  //     const buttonHeight = rect.height;
  //     const top = rect.top + window.scrollY + buttonHeight + 5; // Add height + 10px
  //     const left = rect.left + window.scrollX;

  //     setPosition({ top, left }); // Update position state
  // };


  const statusOptions = [
    { value: "PENDING_REVIEW", label: "Pending Review" },
    { value: "UNDER_REVIEW", label: "Under Review" },
    { value: "ACCEPTED", label: "Accepted" },
    { value: "UPLOADED", label: "Uploaded" },
    { value: "IN_PROGRESS", label: "In Progress" },
    { value: "PUBLISHED", label: "Published"},
    { value: "REJECTED", label: "Rejected" },
    { value: "CANCELLED", label: "Cancelled" },
    { value: "CLOSED", label: "Closed" },
    { value: "OWNERSHIP_TRANSFERRED", label: "Ownership Transferred"},
    {value: "FINALIZED", label: "Finalized"},
    {value: "SOLD", label: "Sold"},
    {value: "ASSIGNED", label: "Assigned"},
    {value: "DELIVERED", label: "Delivered"},
    {value: "UNPUBLISHED", label: "Unpublished"},
    {value: "REPUBLISHED", label: "Republished"},
    {value: "DELETED", label: "Deleted"},
    {value: "IN_TRANSIT", label: "In Transit"},
    {value: "ADMIN_ACCEPTED", label: "Admin Accepted"},
    {value: "ADMIN_REJECTED", label: "Admin Rejected"},
    {value: "INVOICE_SENT", label: "Invoice Sent"},
    {value: "COMPLETED", label: "Completed"},
    {value: "PAYMENT_RECEIVED", label: "Payment Received"},
    {value: "RE_PROCESSING", label: "Re Processing"},
    {value: "SEND_TO_OWNER", label: "Send to Owner"},
    {value: "SEND_TO_WAREHOUSE", label: "Send to Warehouse"},
    {value: "IN_PROCESS", label: "In Process"},
    {value: "REASSIGN_TO_ADMIN", label: "Reassign to Admin"},
    {value: "CONFIRMED_FOR_WAREHOUSE", label: "Confirmed for Warehouse"},
    {value: "IN_STAGE_FOR_WAREHOUSE", label: "In Stage for Warehouse"},
    {value: "ADMIN_ACCEPTED_FOR_WAREHOUSE", label: "Admin Accepted for Warehouse"},
    {value: "WAREHOUSE_COMPLETED", label: "Warehouse Completed"},
    {value: "CHECKED", label: "Checked"},
    {value: "CONFIRMED", label: "Confirmed"},
    {value: "IN_STAGE", label: "In Stage"},
    {value: "SCHEDULED", label: "Scheduled"},
    {value: "SOURCE_ACCEPTED", label: "Source Accepted"},
    {value: "DESTINATION_ACCEPTED", label: "Destination Accepted"},
    {value: "SOURCE_REJECTED", label: "Source Rejected"},
    {value: "DESTINATION_REJECTED",label: "Destination Rejected"}
  ];

  const initialFilter = {
    name: null,
    status: null,
    createdDate: null,
    requestNumber: null,
    requestType: null,
    companyName: null
  };

  const _filterInitRef = useRef(false);
  if (!_filterInitRef.current) {
    _filterInitRef.current = true;
    if (!consumeNavigationPreserve("support-request")) {
      clearNamespace("support-request");
    }
  }

  const [page, setPage] = usePersistentState<number>("support-request", "page", 0);
  const [pageSize, setPageSize] = usePersistentState<number>("support-request", "pageSize", 50);
  const [filter, setFilter] = usePersistentState<any>("support-request", "filter", initialFilter);
  const controllerRef = useRef<AbortController | null>(null);

  useEffect(() => {
   
    const receivedData = state?.data;
  
    const updatedFilter = receivedData 
      ? { ...filter, requestType: receivedData } 
      : filter;
  
    setFilter(updatedFilter);
  
    // Use the appropriate filter in the API calls
    loadAllServiceRequests(page, pageSize, updatedFilter, sortField, sortDirection);
    fetchAllServices();
    
    
  }, []);

  useEffect(() => {
  
    const handleClickOutside = (event: MouseEvent) => {
      if (
        divRef.current &&
        !divRef.current.contains(event.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        setShowDropdown(false);
      }
    };
  
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      
    };
  }, [showDropdown]); // Only run when dropdown is toggled



 
  
  const loadAllServiceRequests = async (page: any, size: any, filter: any, sortField: any, sortDirection: any) => {
    
    const controller = new AbortController();
    const signal = controller.signal;
  
    try {
      setIsLoading(true);
      setSupportRequests([]);
   //   setTableDataWithIds([]);
      // setTotalCount(0);
      // Cancel the previous request if any

      if (controllerRef.current) {
        setIsLoading(true);
        controllerRef.current.abort();
      }
      
      // Store the current controller to cancel the request if needed
      controllerRef.current = controller;
  
      const response = await SupportApiService.getAllServiceRequests(
        id ? id : (CommonService.isUser() ? CommonService.getCompanyId(): null),
        page,
        size,
        filter,
        sortField,
        sortDirection,
        signal
      );
  
      setSupportRequests(response.data.content);
      setTotalCount(response.data.totalElements);
      setIsLoading(false);
    } catch (error) {
      // Handle cancellation error or any other error
      if (error.name === 'AbortError') {
        console.log('Previous request was canceled');
      } else {
        setIsLoading(false);
        console.error("Error fetching support requests:", error);
      }
    }
  };

  const fetchAllServices = async () => {
    try {
      setIsLoading(true);
      const response = await SupportApiService.getAllServiceType();
      setServices(response.data);
    } catch (error) {
      console.log("Error occurred while API calling:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const CellWithTooltip = ({ value }: { value: string | number }) => {
    return (
      <Tooltip arrow title={value?.toString() || ""}>
        <span>{value?.toString() || "-"}</span>
      </Tooltip>
    );
  };

  const handleEditServiceRequest = (id:any) => {
    const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
    markNavigationPreserve("support-request");
    history.push(`${linkPrefix}/edit-customer-service-request/${id}`, { fromInternal: true });
 }


    const deleteServiceRequest = async(id:any) => {

        Swal.fire({
            html: `
            <style>
              .custom-swal .icon-container {
                  background-color: #ffebee;
                  border-radius: 50%;
                  width: 105px;
                  height: 105px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin: 0 auto 20px;
                }
                .custom-swal .icon-container i {
                  color: #ff3e4e;
                  font-size: 24px;
                }
                .custom-swal h2 {
                  font-size: 20px;
                  margin-bottom: 10px;
                  margin-top: 20px;
                }
                .custom-swal p {
                  font-size: 14px;
                  color: #666;
                  margin-bottom: 20px;
                }
                .custom-swal .button-container {
                  margin-top: 40px;
                  display: flex;
                  justify-content: center;
                  gap: 20px;
                }
                .custom-swal button {
                  border: none;
                  padding: 10px 50px;
                  border-radius: 30px;
                  font-size: 14px;
                  cursor: pointer;
                }
                .custom-swal .cancel-btn {
                  background-color: #e0e0e0;
                  color: #333;
                }
                .custom-swal .delete-btn {
                  background-color: #ec2323;
                  color: white;
                }
                
            </style>
            <div class="custom-swal">
      
            <div class="icon-container" id="iconContainer">
              </div>
      
              <h2>Are you sure?</h2>
              <p>Remove service request</p>
              <div class="button-container">
                <button class="cancel-btn" id="cancelBtn">Cancel</button>
                <button class="delete-btn" id="deleteBtn">Remove</button>
              </div>
            </div>
          `,
            showConfirmButton: false,
            showCancelButton: false,
            showCloseButton: true,
            focusCancel: true,
            customClass: {
              popup: "custom-popup",
            },
            backdrop: `rgba(0,0,0,0.4)`,
            width: "500px",
            background: "#f8f8f8",
            didOpen: () => {
              // Add the image after the popup has been rendered
              const iconContainer = Swal.getPopup()!.querySelector("#iconContainer");
              if (iconContainer) {
                const img = document.createElement("img");
                img.src = DeleteItemIcon;
                img.width = 47;
                img.height = 51;
                iconContainer.appendChild(img);
              }
      
              // Add event listeners to the buttons
              const cancelBtn = Swal.getPopup()!.querySelector("#cancelBtn");
              const deleteBtn = Swal.getPopup()!.querySelector("#deleteBtn");
      
              cancelBtn?.addEventListener("click", () => {
                Swal.close();
              });
    
              deleteBtn?.addEventListener("click", async () => {
                // Remove the item from the cart locally
                
      
                
          try {
            const response = await SupportApiService.deleteCustomerServiceRequest(id);
    
             // After removing the service request, show this message
             setTimeout(() => {
                 CommonService.Toast.fire({
                 title: "Service request removed successfully",
                 icon: "success",
              });
              
                          }, 1000);
            loadAllServiceRequests(page, pageSize, filter, sortField, sortDirection);
            const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
            history.push(`${linkPrefix}/customer-service`);
        } catch(error ) {
            console.error("Error deleting service request:", error);
        }
      
                Swal.close();
              });
            },
          });

    }

    //redirect to the add support request page
    const handleAddRequest = () => {
        if (CommonService.isAdmin())
            history.push("/master/add-customer-service-request", {
            data: state?.data,  // Your data here
            companyId: state?.companyId
        });
        else
            history.push("/user/add-customer-service-request", {
            data: state?.data, // Your data here
        });
    };

    const handleRowClick = (params) => {
        const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
        markNavigationPreserve("support-request");
        history.push(`${linkPrefix}/view-customer-service-request/${params.row.id}`, { fromInternal: true });
    }

    // const handleFilterChange = (event: any, value: string) => {
    //   const isChecked = event.target.checked;
    
    //   // Toggle the selected status
    //   const updatedStatus = isChecked
    //     ? [...filter.status, value] // Add status
    //     : filter.status.filter((status) => status !== value); // Remove status
    
    //   // Update state
    //   setFilter({ ...filter, status: updatedStatus });
    
    //   // Reload service requests with updated filters
    //   loadAllServiceRequests(page, pageSize, { ...filter, status: updatedStatus });
    // };

  // const [filters, setFilters] = useState({
  //   requestType: "",
  //   requestNumber: "",
  //   createdDate: "",
  //   name: "",
  //   status: "",
  // });

  const handleFilterChange = (
    event: any,
    field: keyof ServiceRequestSearchFilter
  ) => {
    let value = event.target.value;
    if (typeof value === "string") {
      value = value.trimStart().trimEnd();
    }
  
    // Prepare a temporary filter object with the updated field value
    const tempFilter = {
      ...filter, // Spread existing filter state
      [field]: value, // Update the specific field
    };
  
    // Store the cursor position
    cursorPosition.current = event.target.selectionStart;

    // Update the filter state
    setFilter(tempFilter);
    // setIsLoading(true);
    // Load the service requests with updated filters
    loadAllServiceRequests(page,pageSize, tempFilter, sortField, sortDirection);
  };

  const handleStatusChange = (event: any, value: string, status: string | null) => {
    const isChecked = event.target.checked;
  
    // Convert the status string to an array
    const statusArray = status ? status.split(",") : [];
  
    // Update the status list based on checkbox state
    const updatedStatusArray = isChecked
      ? [...statusArray, value] // Add status if checked
      : statusArray.filter((s) => s !== value); // Remove status if unchecked
  
    // Convert array back to a comma-separated string
    const updatedStatus = updatedStatusArray?.length > 0 ? updatedStatusArray.join(",") : null;
  
    // Update the filter state with the modified status string
    setFilter({ ...filter, status: updatedStatus }); 
 
    // Reload service requests with updated filters
    loadAllServiceRequests(page, pageSize, { ...filter, status: updatedStatus }, sortField, sortDirection);
  };

  const handleClose = () => {
    setShow(false);
    setError("");
    setReason("");
    setFeeError("");
    setAgreeError("");
    setOwnershipName("");
    setOwnershipNameError("");
    setTrackNumberError("");
    setFeeTypeError("");
    setWarehouseError("");
    setTransferCompanyError("");
    setSelectedTransferCompany("");
    setSelectedWarehouseUser("");
    setSellRequestFee("");
    setSellRequestFeeType("");
    setTrackNumber("");
    setFlow("");
    setSellRequestFeeUpdated(false)
    setSpendHour("");
    setIsRejected(false);
    setIsCancelled(false);
    setSellRequestAccepted(false);
    setIsBeforeCancel(false);
    setInTransit(false);
    setIsReopenConfirm(false);
  };

  const handleSellRequestFeeChange = (e) => {
    setFeeError('');
    const value = e.target.value;
    setSellRequestFee(value);
  }

  const handleSellRequestFeeTypeChange = (e) => {
    setFeeTypeError('');
    const value = e.target.value;
    setSellRequestFeeType(value);
  }

  const handleWarehouseUserChange = (selectedOption) => {
    setWarehouseError('');
    setSelectedWarehouseUser(selectedOption ? selectedOption.value : '');
  };

  const handleTransferCompanyChange = (selectedOption) => {
    setTransferCompanyError('');
    setSelectedTransferCompany(selectedOption ? selectedOption.value : '');
  };

  const handleInputTrackerNumber = (event) => {
    setTrackNumberError("");
    setTrackNumber(event.target.value);
  };

  const handleInputOwnershipName = (event) => {
    setOwnershipNameError("");
    setOwnershipName(event.target.value);
  }

  const handleInputFlow = (event) => {
    setFlowError("");
    setFlow(event.target.value);
  };

  const handleReasonChange = (e:any) => {
    setError("");
    setReason(e.target.value);
  }

  const handleSpendHourChange = (e:any) => {
    const value = e.target.value.trim();
    const numericValue = Number(value);

    if (!value) {
      setError("Time spent is required");
      setSpendHour("");
    } else if (numericValue < 1) {
      setError("Time spent must be at least 1 hour");
      setSpendHour("");
    } else if (numericValue > 24) {
      setError("Time spent cannot exceed 24 hours");
      setSpendHour("24");
    } else {
      setError("");
      setSpendHour(value);
    }
  }

  const updateSellRequestFeeDetails = async () => {

    let isValid = true;

    //check entered value is valid or not
    if((Number(sellRequestFee)) < 0 || sellRequestFee?.trim().length < 1) {
      setFeeError((sellRequestFee?.trim().length < 1)? "Please enter commission fee" : "Commission Fee should be greater then or equal to zero")
      isValid = false;
    }
    if(sellRequestFeeType == '') {
      setFeeTypeError("Please select fee type")
      isValid = false;
    }


    if(!isValid) {
      return ;
    }

    setIsLoading(true);

    const updateSellRequestDetails = {
      customerServiceRequestId: serviceRequestUpdateStatus.current.customerServiceRequestId,
      fee: sellRequestFee,
      feeType: sellRequestFeeType
    };

    try{
      const response = await SupportApiService.updateSellRequestFeeDetails(updateSellRequestDetails);
      CommonService.Toast.fire({
        title: "Fee Details updated successfully",
        icon: "success",
      });

      // getCustomerServiceRequestDetails();

    } catch(error) {
      console.log("error occurred while api calling");
      
    } finally {
      setIsLoading(false);
      handleClose();
    }
  }

  const updateSampleRequestDetails = async () => {

    if(trackNumberValue == '') {
      setTrackNumberError("Please enter track number");
      return;
    }
    setIsLoading(true);

    const updateSampleRequestDetails = {
      customerServiceRequestId: serviceRequestUpdateStatus.current.customerServiceRequestId,
      serviceName: serviceRequestUpdateStatus.current?.serviceName,
      companyId: serviceRequestUpdateStatus.current?.companyId,
      userId: serviceRequestUpdateStatus.current?.userId,
      requestNumber: serviceRequestUpdateStatus.current?.requestNumber,
      trackNumber: trackNumberValue,
      status: serviceRequestUpdateStatus.current.status
    };

    try{
      const response = await SupportApiService.updateSampleRequestDetails(updateSampleRequestDetails);
      CommonService.Toast.fire({
        title: "Sample request Details updated successfully",
        icon: "success",
      });
      loadAllServiceRequests(page, pageSize, filter, sortField, sortDirection);
    } catch(error) {
      console.log("error occurred while api calling");
    } finally {
      setIsLoading(false);
      handleClose();
    }
  }

  // const handleUpdateStatus = async(newStatus:any, id:any, serviceName:any, companyId:any, userId:any, sellRequestFee:any, sellRequestFeeType:any) => {
    
  //   console.log("these are my fields " + serviceName, companyId, userId, sellRequestFee, sellRequestFeeType)
  //   const status = newStatus?.replace(/ /g, "_").toUpperCase();
    
  //   const currentStatus = {
  //     customerServiceRequestId: id,
  //     serviceName: serviceName,
  //     reason: "",
  //     status: status,
  //     spendHourOnRequest: "",
  //     companyId: companyId,
  //     userId: userId,
  //     // dynamicFields: customerServiceRequest.dynamicFields || [],
  //     fee: sellRequestFee,
  //     feeType: sellRequestFeeType
  //   };

  //   serviceRequestUpdateStatus.current = currentStatus;

  //   if(serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.ACCEPTED && serviceName == 'Sell Request') {
  //     setSellRequestAccepted(true);
  //     setIsCancelled(false);
  //     setIsRejected(false);
  //     handleShow();
  //   } else if (serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.CANCELLED) {
  //     setIsCancelled(true);
  //     setIsRejected(false);
  //     setSellRequestAccepted(false);
  //     handleShow();
  //   } else if (serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.REJECTED) {
  //     setIsRejected(true);
  //     setIsCancelled(false);
  //     setSellRequestAccepted(false);
  //     handleShow();
  //   } else if (serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.CLOSED) {
  //     setIsCancelled(false);
  //     setIsRejected(false);
  //     setSellRequestAccepted(false);
  //     handleShow();
  //   } else {
  //     //if status is not ACCEPTED and REJECTED then call method don't open any popup
  //     changeCustomerServiceRequestStatus(serviceName);
  //   }

  // }

  const handleUpdateStatus = async(newStatus:any, oldStatus:any, id:any, serviceName:any, requestNumber: any, companyId:any, userId:any, sellRequestFee:any, sellRequestFeeType:any, trackNumberValue:any, flowValue:any, companyName:any, destinationCompanyName:any) => {
    
    const status = newStatus?.replace(/[\s-]/g, "_").toUpperCase()
    
    const currentStatus = {
      customerServiceRequestId: id,
      serviceName: serviceName,
      requestNumber: requestNumber,
      reason: "",
      status: status,
      spendHourOnRequest: "",
      companyId: companyId,
      userId: userId,
      dynamicFields: [],
      fee: sellRequestFee,
      feeType: sellRequestFeeType,
      trackNumber: trackNumberValue,
      flow: flowValue,
      assignedTo: selectedWarehouseUser,
      destinationCompanyAcceptedByName: "",
      sourceCompanyAcceptedByName: ""
    };

    serviceRequestUpdateStatus.current = currentStatus;

    if (
        ((status === Constant.CustomerServiceRequestStatus.COMPLETED) || status ===
          Constant.CustomerServiceRequestStatus.WAREHOUSE_COMPLETED) &&
        serviceRequestUpdateStatus.current.serviceName ===
          Constant.CustomerService.BARREL_PROOFING
      ) {
        const isPresent =
          await SupportApiService.checkAllBarrelProofingValuePresent(
            serviceRequestUpdateStatus.current.customerServiceRequestId);
        if (!isPresent.data) {
          const message = CommonService.isAdmin()
            ? "Cannot close request: selected container are missing proof values. Please add them before closing."
            : "Please add Proof value for all selected container before reassigning to admin.";

          CommonService.Toast.fire({
            title: message,
            icon: "error",
          });
          handleClose();
          return;
        }
      }
      
      if (((serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.COMPLETED) ||  serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.WAREHOUSE_COMPLETED) &&
            serviceRequestUpdateStatus.current.serviceName === Constant.CustomerService.BARREL_VALUATION) {
        const isPresent = await SupportApiService.checkAllBarrelValuationValuePresent(
          serviceRequestUpdateStatus.current.customerServiceRequestId);
        if (!isPresent.data) {
          const message = CommonService.isAdmin()
            ? "Cannot complete request: selected container are missing valuation cost. Please add them before closing."
            : "Please add Valuation cost for all selected container before reassigning to admin.";

          CommonService.Toast.fire({
            title: message,
            icon: "error",
          });
          handleClose();
          return;
        }
      }

      if (((serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.COMPLETED) ||  serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.WAREHOUSE_COMPLETED) &&
            serviceRequestUpdateStatus.current.serviceName === Constant.CustomerService.TASTING) {
        const isPresent = await SupportApiService.checkAllBarrelTastingNoteValuePresent(
          serviceRequestUpdateStatus.current.customerServiceRequestId);
        if (!isPresent.data) {
          const message = CommonService.isAdmin()
            ? "Cannot complete request: selected container are missing tasting details. Please add them before closing."
            : "Please add Tasting Details for all selected container before reassigning to admin.";

          CommonService.Toast.fire({
            title: message,
            icon: "error",
          });
          handleClose();
          return;
        }
      }

    if ((serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.COMPLETED || serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.WAREHOUSE_COMPLETED) &&
      (serviceRequestUpdateStatus.current.serviceName === Constant.CustomerService.BLENDING_REQUEST || serviceRequestUpdateStatus.current.serviceName === Constant.CustomerService.RE_CONTAINERIZATION)) {
      const isPresent = await SupportApiService.checkAllDestinationBarrelValuePresent(
        serviceRequestUpdateStatus.current.customerServiceRequestId, serviceRequestUpdateStatus.current.serviceName);
      if (!isPresent.data) {
        const message = CommonService.isAdmin()
          ? "Cannot complete request: selected container are missing destination container details. Please add them before closing."
          : "Please add Destination Container Details for all selected container before reassigning to admin.";

        CommonService.Toast.fire({
          title: message,
          icon: "error",
        });
        handleClose();
        return;
      }
    }
      
      
    if(serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.ACCEPTED && serviceName == 'Sell Request') {
      setSellRequestAccepted(true);
      setOwnershipTransferedAccepted(false);
      setIsCancelled(false);
      setIsRejected(false);
      setInTransit(false);
      setIsInWarehouse(false);
      handleShow();
    } else if (serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.ACCEPTED && serviceName == 'Ownership Transfer') {
      setSellRequestAccepted(false);
      setIsCancelled(false);
      setIsRejected(false);
      setInTransit(false);
      setIsInWarehouse(false);
      fetchAllActiveAndInactiveCompanies();
    } else if (serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.CANCELLED) {
      setIsCancelled(true);
      setIsRejected(false);
      setSellRequestAccepted(false);
      setOwnershipTransferedAccepted(false);
      setInTransit(false);
      setIsInWarehouse(false);
      if(oldStatus == Constant.CustomerServiceRequestStatus.PENDING_REVIEW || oldStatus == Constant.CustomerServiceRequestStatus.UNDER_REVIEW) {
        setIsBeforeCancel(true);
      }
      handleShow();
    } else if (serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.REJECTED || serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.ADMIN_REJECTED) {
      setIsRejected(true);
      setIsCancelled(false);
      setSellRequestAccepted(false);
      setOwnershipTransferedAccepted(false);
      setInTransit(false);
      setIsInWarehouse(false);
      handleShow();
    } else if (serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.CLOSED) {
      if (serviceRequestUpdateStatus.current.serviceName === Constant.CustomerService.PRIVATE_SELL) {
        changeCustomerServiceRequestStatus();
      } else {
        setIsCancelled(false);
        setIsRejected(false);
        setSellRequestAccepted(false);
        setOwnershipTransferedAccepted(false);
        setInTransit(false);
        setIsInWarehouse(false);
        handleShow();
      }
    } else if(serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.IN_TRANSIT && (serviceName == Constant.CustomerService.SAMPLE_REQUEST || serviceName == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST)) {
      setInTransit(true);
      setSellRequestAccepted(false);
      setOwnershipTransferedAccepted(false);
      setIsCancelled(false);
      setIsRejected(false);
      setIsInWarehouse(false);
      handleShow();
    } else if (serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.SEND_TO_WAREHOUSE) {
      setIsInWarehouse(true);
      setIsCancelled(false);
      setIsRejected(false);
      setSellRequestAccepted(false);
      setOwnershipTransferedAccepted(false);
      setInTransit(false);
      let response = await SupportApiService.fetchAllWarehouseUser();
      setWarehouseUserList(response.data);
      handleShow();
    } else if (status === Constant.CustomerServiceRequestStatus.SOURCE_ACCEPTED || status === Constant.CustomerServiceRequestStatus.DESTINATION_ACCEPTED) {
      setSourceCompanyAccepted(true);
      setDestinationCompanyName(destinationCompanyName)
      setSourceCompanyName(companyName);
      setSelectedCompanyRequest(companyId);
      setSourceCompanyRejected(false);
      setInTransit(false);
      setSellRequestAccepted(false);
      setOwnershipTransferedAccepted(false);
      setIsCancelled(false);
      setIsRejected(false);
      setIsInWarehouse(false);
      handleShow();
    } else if (status === Constant.CustomerServiceRequestStatus.SOURCE_REJECTED || status === Constant.CustomerServiceRequestStatus.DESTINATION_REJECTED) {
      setSourceCompanyRejected(true);
      setSourceCompanyAccepted(false);
      setInTransit(false);
      setSellRequestAccepted(false);
      setOwnershipTransferedAccepted(false);
      setIsCancelled(false);
      setIsRejected(false);
      setIsInWarehouse(false);
      handleShow();
    } else if (status === Constant.CustomerServiceRequestStatus.RE_OPEN) {
      setSourceCompanyRejected(false);
      setSourceCompanyAccepted(false);
      setInTransit(false);
      setSellRequestAccepted(false);
      setOwnershipTransferedAccepted(false);
      setIsCancelled(false);
      setIsRejected(false);
      setIsInWarehouse(false);
      setIsReopenConfirm(true);
      handleShow();
    } else {

      //now check if the status is uploaded then add the dynamic field in request 
      if(serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.UPLOADED || serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.PUBLISHED) {
         try {
           const response = await SupportApiService.getCustomerServiceRequest(id);
           serviceRequestUpdateStatus.current.dynamicFields = response.data?.dynamicFields;
           serviceRequestUpdateStatus.current.companyId = response.data?.companyId;
           serviceRequestUpdateStatus.current.userId = response.data?.userId;
         } catch (error) {
           console.log("error occurred while api calling ");
         }
      }
      //if status is not ACCEPTED and REJECTED then call method don't open any popup
      changeCustomerServiceRequestStatus(oldStatus);
    }

  }

  const changeCustomerServiceRequestStatus = async(oldStatus?:any) => {
  
      if ((serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.REJECTED || serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.ADMIN_REJECTED) && reason.trim().length <= 0) {
        setError("Please enter rejection reason");
        return;
      }

      if((serviceRequestUpdateStatus.current.status == Constant.CustomerServiceRequestStatus.SOURCE_ACCEPTED || serviceRequestUpdateStatus.current.status == Constant.CustomerServiceRequestStatus.DESTINATION_ACCEPTED)  && (ownershipName.trim().length <= 0 || !isAgreed)) {
        setAgreeError(!isAgreed ? "Consent is required to treat your name as an electronic signature.": "");
        setOwnershipNameError(ownershipName.trim().length <= 0 ? "Please enter your full name": "");
        return;
      }
  
      if (serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.REJECTED && reason.trim().length > 1000) {
        setError("Rejection note can not be more than 1000 characters");
        return;
      }
  
      if (serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.CLOSED && serviceRequestUpdateStatus.current.serviceName !== Constant.CustomerService.PRIVATE_SELL && spendHour.trim().length <= 0) {
        setError("Please enter spend time in hours");
        return;
      }

      if(serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.SEND_TO_WAREHOUSE && selectedWarehouseUser == "") {
        setWarehouseError("Please Select Warehouse");
        return;
      }

      if ((serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.ACCEPTED && serviceRequestUpdateStatus.current.serviceName == 'Sell Request') && ((Number(sellRequestFee)) < 0 || sellRequestFeeType == '') ) {
        
        if((Number(sellRequestFee)) < 0 || sellRequestFee?.trim().length < 1) {
          setFeeError((sellRequestFee?.trim().length < 1)? "Please enter commission fee" : "Commission Fee should be greater then or equal to zero")
        }
        if(sellRequestFeeType == '') {
          setFeeTypeError("Please select fee type")
        }
        return ;
      }

      if ((serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.IN_TRANSIT && (serviceRequestUpdateStatus.current.serviceName == Constant.CustomerService.SAMPLE_REQUEST || serviceRequestUpdateStatus.current.serviceName == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST))) {      
        if(trackNumberValue == '') {
          setTrackNumberError("Please enter track number");
        }
        if(flowValue == '') {
          setFlowError("Please enter flow");
        }
        return ;
      }

      setIsLoading(true);
      
      //now call the api and update the status
      try {
        //before calling the api we need to set the reason if status is cancelled and set spend hour if the status Closed
        if(serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.CANCELLED) {
          serviceRequestUpdateStatus.current.reason = reason;
        } else if(serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.REJECTED) {
          serviceRequestUpdateStatus.current.reason = reason;
        } else if(serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.CLOSED) {
          serviceRequestUpdateStatus.current.spendHourOnRequest = spendHour;
        } else if ((serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.ACCEPTED && serviceRequestUpdateStatus.current.serviceName == Constant.CustomerService.SELL_REQUEST)) {
          serviceRequestUpdateStatus.current.fee = sellRequestFee;
          serviceRequestUpdateStatus.current.feeType = sellRequestFeeType;
        } else if ((serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.IN_TRANSIT && (serviceRequestUpdateStatus.current.serviceName == Constant.CustomerService.SAMPLE_REQUEST || serviceRequestUpdateStatus.current.serviceName == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST))) {
          serviceRequestUpdateStatus.current.trackNumber = trackNumberValue;
          serviceRequestUpdateStatus.current.flow = flowValue;
        } else if(serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.SEND_TO_WAREHOUSE) {
          serviceRequestUpdateStatus.current.assignedTo = selectedWarehouseUser;
        } else if (serviceRequestUpdateStatus.current.status == Constant.CustomerServiceRequestStatus.SOURCE_ACCEPTED) {
          serviceRequestUpdateStatus.current.sourceCompanyAcceptedByName = ownershipName
        } else if(serviceRequestUpdateStatus.current.status == Constant.CustomerServiceRequestStatus.DESTINATION_ACCEPTED) {
          serviceRequestUpdateStatus.current.destinationCompanyAcceptedByName = ownershipName
        }
      
        const response = await SupportApiService.updateCustomerServiceRequestStatus(serviceRequestUpdateStatus.current);
        // getCustomerServiceRequestDetails();
        // fetchCustomerServiceRequestHistory();

        setIsLoading(false);
        handleClose();
        
        CommonService.Toast.fire({
          title: "Status updated successfully",
          icon: "success",
        });
        
        loadAllServiceRequests(page, pageSize, filter, sortField, sortDirection);
         
      } catch (error) {
        
        console.log("error occurred while api calling " + error?.response?.data?.errorMessage);

        if(error?.response?.data?.errorMessage == 'REQUEST_CANCELLED') {
          CommonService.Toast.fire({
            title: `This request has already been cancelled and cannot be ${serviceRequestUpdateStatus.current.status === Constant.CustomerServiceRequestStatus.UNPUBLISHED ? 'Unpublished' : 'Deleted'} `,
            icon: "error",
          });
        }
  
        else if (serviceRequestUpdateStatus.current.status == Constant.CustomerServiceRequestStatus.UNPUBLISHED || serviceRequestUpdateStatus.current.status == Constant.CustomerServiceRequestStatus.REPUBLISHED || serviceRequestUpdateStatus.current.status == Constant.CustomerServiceRequestStatus.DELETED) {
          CommonService.Toast.fire({
            title: `${error?.response?.data?.data}`,
            icon: "error",
          });
        } else {
          CommonService.Toast.fire({
            title: `${error?.response?.data?.errorMessage}`,
            icon: "error",
          });
        } 
  
      } finally {
          setIsLoading(false);
      }  
    
    }
  
    const fetchAllActiveAndInactiveCompanies = async () => {
      try {
        const companyResponse = await Service.getAllActiveAndInactiveCompanies();
        const companies = companyResponse.data || [];

        setFilteredActiveInactiveCompaniesList(companies);

        const dynamicFields =
          await SupportApiService.getAllDynamicFieldValueByServiceRequestId(
            serviceRequestUpdateStatus.current.customerServiceRequestId
          );

        let newCompanyId: string | null = null;
        let receivingCompanyName: string | null = null;

        // Extract required fields first (single loop)
        dynamicFields.data.forEach((field: any) => {
          if (field?.fieldName === Constant.Field.NEW_COMPANY) {
            newCompanyId = field.value; // already company id
          }

          if (field?.fieldName === Constant.Field.RECEIVING_COMPANY) {
            receivingCompanyName = field.value; // company name
          }
        });

        // ✅ Priority 1 → NEW_COMPANY (ID directly)
        if (newCompanyId) {
          setSelectedTransferCompany(newCompanyId);
          changeCustomerServiceRequestStatus();
          return;
        }

        // ✅ Priority 2 → old existing logic (name match)
        if (receivingCompanyName) {
          setReceivingCompany(receivingCompanyName);

          const matchedCompany = companies.find(
            (company: any) =>
              company.companyName?.toLowerCase() ===
              receivingCompanyName?.toLowerCase()
          );

          if (matchedCompany) {
            setSelectedTransferCompany(matchedCompany.id);
          }
        }

        setOwnershipTransferedAccepted(true);
        handleShow();
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    };

    const addCompany = async () => {
    
      if(!isReceivingCompanyExist){
  
        setIsLoading(true);
  
        const sanitizedValue = receivingCompany.replace(/[^a-zA-Z0-9]/g, "");
        const email = `${sanitizedValue}@yopmail.com`.toLowerCase(); 
  
        const requestData = {
          companyEmail: email,
          isActive: true,
          isDelete: false,
          companyName: receivingCompany
        };
        try {
          // Save company and get the savedCompanyId
          const response = await Service.addCompany(requestData);
          setSelectedTransferCompany(response.data);
          selectedTransferCompanyRef.current = response.data;
  
          updateTransferCompanyDetails();
        } catch (error) {
          console.error("Company creation or retrieval failed");
          console.error("Error saving company:", error);
          return; // Exit if the company save fails
        } finally{
          setIsLoading(false);
        }
      }
        
    };

    const updateTransferCompanyDetails = async () => {

      if ((isReceivingCompanyExist && selectedTransferCompany == '') || (!isReceivingCompanyExist && selectedTransferCompany == '' && selectedTransferCompanyRef.current == '')) {
        setTransferCompanyError("Please Select Transfer Account Owner");
        return;
      }

      setIsLoading(true);
      let transferCompanyId = selectedTransferCompany || selectedTransferCompanyRef.current;

      const updateTransferCompanyDetails = {
        customerServiceRequestId: serviceRequestUpdateStatus.current.customerServiceRequestId,
        serviceName: serviceRequestUpdateStatus.current?.serviceName,
        companyId: serviceRequestUpdateStatus.current?.companyId,
        userId: serviceRequestUpdateStatus.current?.userId,
        requestNumber: serviceRequestUpdateStatus.current?.requestNumber,
        status: serviceRequestUpdateStatus.current.status,
        newCompanyId: transferCompanyId
      };

      try {
        const response = await SupportApiService.updateOwnershipTransferRequestCompanyDetails(updateTransferCompanyDetails);
        CommonService.Toast.fire({
          title: "Ownership transfer request details updated successfully",
          icon: "success",
        });
        loadAllServiceRequests(page, pageSize, filter, sortField, sortDirection);
      } catch (error) {
        console.log("error occurred while api calling" + error);
        if (error?.response?.data?.errorMessage) {
          CommonService.Toast.fire({
            title: `${error?.response?.data?.errorMessage}`,
            icon: "error"
          });
        }

      } finally {
        setIsLoading(false);
        handleClose();
      }

    } 
  
  // Apply the filters to the rows
  //   const filteredRows = supportRequests.filter((row) => {
  //     return (
  //       row.requestType
  //         .toLowerCase()
  //         .includes(filters.requestType.toLowerCase()) &&
  //       row.requestNumber
  //         .toLowerCase()
  //         .includes(filters.requestNumber.toLowerCase()) &&
  //       row.createdDate
  //         .toLowerCase()
  //         .includes(filters.createdDate.toLowerCase()) &&
  //       row.name.toLowerCase().includes(filters.name.toLowerCase()) &&
  //       row.status.toLowerCase().includes(filters.status.toLowerCase())
  //     );
  //   });

  // Map filtered rows with unique IDs
//   const tableDataWithIds = supportRequests.map((rowData, index) => ({
//     ...rowData,
//     id: rowData.supportRequestId, // Assigning a unique ID based on the index
//   }));

  const columns: GridColDef[] = [
    {
      field: "requestNumber",
      headerName: "Request Number",
      headerClassName: "table-header border-0 my-2 h-100",
      minWidth: 200,
      flex: 1,
      sortable: true,
      renderCell: (params) => <CellWithTooltip value={params.value} />,
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <div className="position-relative" style={{ width: "165px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search Request"
              //value={filter.requestNumber}
              defaultValue={filter.requestNumber}
              onFocus={(e) => {
                // Restore the cursor position on focus
                if (cursorPosition.current !== null) {
                  e.target.selectionStart = cursorPosition.current;
                }
              }}
              onChange={(event) => handleFilterChange(event, "requestNumber")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div>
        </div>
      ),
    },

    {
      field: "requestType",
      headerName: "Request Type",
      headerClassName: "table-header border-0 my-2 h-100",
      minWidth: 250,
      flex: 1,
      sortable: true,
      renderCell: (params) => {
        const { requestType, requestTitle } = params.row;
        const displayValue = requestTitle
          ? `${requestType} (${requestTitle})`
          : requestType;

        return <CellWithTooltip value={displayValue} />;
      },
      renderHeader: (params) => (
        <>
          <div>
            <Typography
              variant="body2"
              sx={{ color: "#6F6F6F", fontSize: "14px" }}
            >
              {params.colDef.headerName}
            </Typography>
            <div
              ref={dropdownRef}
              className="position-relative"
              style={{ width: "200px" }}
              onClick={(e) => e.stopPropagation()} // prevent bubbling to parents
            >
              <Dropdown show={showReqType}>
                <Dropdown.Toggle
                  variant="light"
                  className="w-100 border mt-1 form-select custom-dropdown-toggle text-start"
                  id="dropdown-custom-select"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowReqType((prev) => !prev); // ✅ toggle open/close
                  }}
                >
                  {filter.requestType || "Select Request Type"}
                </Dropdown.Toggle>

                {showReqType && (
                  <Dropdown.Menu className="custom-dropdown-menu w-100 show">
                    {services.map((service) => (
                      <Dropdown.Item
                        key={service.id}
                        onClick={(event) => handleSelect(event, service.serviceName)}
                        active={filter.requestType === service.serviceName}
                      >
                        {service.serviceName}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                )}
              </Dropdown>
            </div>
          </div>
        </>
      ),
    },
    // Conditionally include the 'Company' column for admins
    ...(CommonService.isAdmin()
      ? [
          {
            field: "companyName",
            headerName: "Account Owner",
            headerClassName: "table-header border-0 my-2 h-100",
            minWidth: 200,
            flex: 1,
            sortable: true,
            renderCell: (params) => <CellWithTooltip value={params.value} />,
            renderHeader: (params) => (
              <div>
                <Typography
                  variant="body2"
                  sx={{ color: "#6F6F6F", fontSize: "14px" }}
                >
                  {params.colDef.headerName}
                </Typography>
                <div className="position-relative" style={{ width: "165px" }}>
                  <input
                    type="text"
                    className="form-control border mt-1"
                    style={{ textIndent: "24px", boxShadow: "none" }}
                    placeholder="Search Account Owner"
                    //value={filter.name}
                    defaultValue={filter.companyName}
                    onChange={(event) =>
                      handleFilterChange(event, "companyName")
                    }
                    onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    onFocus={(e) => {
                      // Restore the cursor position on focus
                      if (cursorPosition.current !== null) {
                        e.target.selectionStart = cursorPosition.current;
                      }
                    }}
                  />
                  <SearchIcon
                    sx={{
                      color: "#6F6F6F",
                      position: "absolute",
                      top: "50%",
                      left: "8px",
                      transform: "translateY(-50%)",
                    }}
                  />
                </div>
              </div>
            ),
          },
        ]
      : []),
    {
      field: "name",
      headerName: "User",
      headerClassName: "table-header border-0 my-2 h-100",
      minWidth: 200,
      flex: 1,
      sortable: true,
      renderCell: (params) => <CellWithTooltip value={params.value} />,
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <div className="position-relative" style={{ width: "165px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search User"
              //value={filter.name}
              defaultValue={filter.name}
              onFocus={(e) => {
                // Restore the cursor position on focus
                if (cursorPosition.current !== null) {
                  e.target.selectionStart = cursorPosition.current;
                }
              }}
              onChange={(event) => handleFilterChange(event, "name")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div>
        </div>
      ),
    },
    {
      field: "createdDate",
      headerName: "Requested On",
      headerClassName: "table-header border-0 my-2 h-100",
      minWidth: 200,
      flex: 1,
      sortable: true,
      renderCell: (params: any) => <CellWithTooltip value={params.value} />,
      valueGetter: (value: any, row: any) => {
        const dateTimeString = row.createdDate ? row.createdDate : null;
        if (dateTimeString) {
          return CommonService.formatDateTime(dateTimeString);
        }
      },
      renderHeader: (params) => (
        <div style={{ width: "165px" }}>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <input
            type="date"
            className="form-control border mt-1"
            style={{ boxShadow: "none" }}
            id="birthdate"
            name="birthdate"
            placeholder="Select Date"
            //value={filter.createdDate}
            defaultValue={filter.createdDate}
            onChange={(event) => handleFilterChange(event, "createdDate")}
            onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
          />
        </div>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      headerClassName: "table-header border-0 my-2 h-100",
      minWidth: 300,
      cellClassName: "status-badge",
      flex: 1,
      sortable: true,
      renderCell: (params: any) => (
        <>
          <div
            className="dropdown-nospacing d-flex align-items-center h-100"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Show Spinner while status is UPLOADING */}
            {((params.row.status === "UPLOADING" && params.row.requestType === Constant.CustomerService.BULK_INVENTORY_UPLOAD)
            || (params.row.status === "PROCESSING" && params.row.requestType === Constant.CustomerService.LOGISTIC)) && 
              <div className="upload-spinner-wrapper">
                <Spinner />
                </div>
                }
            <StatusDropdown
              currentStatus={
                params.row.status === "UPLOADING"
                  ? "Uploading"
                  : params.row.status == "PROCESSING"
                  ? "Processing"
                  : params.row.status
              }
              disableCondition={
                (params.row.status ===
                  Constant.CustomerServiceRequestStatus.CLOSED &&
                  params.row.requestType !== Constant.CustomerService.SELL_REQUEST) ||
                params.row.status ===
                  Constant.CustomerServiceRequestStatus.DELETED ||
                params.row.status ===
                  Constant.CustomerServiceRequestStatus.REJECTED ||
                params.row.status ===
                  Constant.CustomerServiceRequestStatus.UPLOADING ||
                params.row.status ===
                  Constant.CustomerServiceRequestStatus.PROCESSING ||
                params.row.status ===
                  Constant.CustomerServiceRequestStatus.FAILED ||
                params.row.status === 
                  Constant.CustomerServiceRequestStatus.ADMIN_REJECTED ||
                (CommonService.isUser() && !params.row?.isDestinationCompany &&
                  (params.row.status ===
                    Constant.CustomerServiceRequestStatus
                      .OWNERSHIP_TRANSFERRED ||
                    params.row.status ===
                      Constant.CustomerServiceRequestStatus.UPLOADED ||
                    params.row.status ===
                      Constant.CustomerServiceRequestStatus.CANCELLED ||
                    params.row.status ===
                      Constant.CustomerServiceRequestStatus.ASSIGNED ||
                    params.row.status ===
                      Constant.CustomerServiceRequestStatus.SOURCE_ACCEPTED ||
                    params.row.status ===
                      Constant.CustomerServiceRequestStatus.SOURCE_REJECTED ||
                    params.row.status ===
                      Constant.CustomerServiceRequestStatus.SOLD || 
                    params.row.status ===
                     Constant.CustomerServiceRequestStatus.UPLOAD_FAILED ||
                    params.row.status ===
                        Constant.CustomerServiceRequestStatus.SEND_TO_WAREHOUSE ||
                    params.row.status ===
                        Constant.CustomerServiceRequestStatus.IN_PROCESS ||
                    params.row.status ===
                        Constant.CustomerServiceRequestStatus.REASSIGN_TO_ADMIN ||
                    params.row.status ===
                        Constant.CustomerServiceRequestStatus.DESTINATION_ACCEPTED ||
                    params.row.status ===
                        Constant.CustomerServiceRequestStatus.DESTINATION_REJECTED ||
                    params.row.status ===
                        Constant.CustomerServiceRequestStatus.CONFIRMED_FOR_WAREHOUSE ||
                    params.row.status ===
                        Constant.CustomerServiceRequestStatus.IN_STAGE_FOR_WAREHOUSE ||
                    params.row.status ===
                        Constant.CustomerServiceRequestStatus.ADMIN_ACCEPTED_FOR_WAREHOUSE ||
                    params.row.status ===
                        Constant.CustomerServiceRequestStatus.WAREHOUSE_COMPLETED ||
                    params.row.status ===
                        Constant.CustomerServiceRequestStatus.COMPLETED ||
                    params.row.status ===
                        Constant.CustomerServiceRequestStatus.CONFIRMED ||
                    params.row.status ===
                        Constant.CustomerServiceRequestStatus.IN_STAGE ||
                    params.row.status ===
                        Constant.CustomerServiceRequestStatus.SCHEDULED ||
                    params.row.status ===
                        Constant.CustomerServiceRequestStatus.ADMIN_ACCEPTED ||
                    ((params.row.requestType === Constant.CustomerService.SAMPLE_REQUEST ||params.row.requestType === Constant.CustomerService.CUSTOM_SAMPLE_REQUEST 
                      || params.row.requestType === Constant.CustomerService.LOGISTIC || params.row.requestType === Constant.CustomerService.RE_CONTAINERIZATION 
                      || params.row.requestType === Constant.CustomerService.BARREL_HEAD_PAINTING || params.row.requestType === Constant.CustomerService.BLENDING_REQUEST 
                      || params.row.requestType === Constant.CustomerService.BOTTLING_REQUEST || params.row.requestType === Constant.CustomerService.DUMPING_REQUEST
                      || params.row.requestType === Constant.CustomerService.TASTING || params.row.requestType === Constant.CustomerService.BARREL_REPAIR_REQUEST
                      || params.row.requestType === Constant.CustomerService.BARREL_PROOFING || params.row.requestType === Constant.CustomerService.BARREL_VALUATION) &&
                      (params.row.status ===
                        Constant.CustomerServiceRequestStatus.ADMIN_ACCEPTED ||
                      params.row.status ===
                        Constant.CustomerServiceRequestStatus.ADMIN_REJECTED ||
                      params.row.status ===
                        Constant.CustomerServiceRequestStatus.REJECTED ||
                      params.row.status ===
                        Constant.CustomerServiceRequestStatus.ACCEPTED || 
                      params.row.status ===
                        Constant.CustomerServiceRequestStatus.IN_PROGRESS ||
                      params.row.status ===
                        Constant.CustomerServiceRequestStatus.INVOICE_SENT ||
                      params.row.status === 
                        Constant.CustomerServiceRequestStatus.DELIVERED ||
                      params.row.status ===
                        Constant.CustomerServiceRequestStatus.PAYMENT_RECEIVED ||
                      params.row.status ===
                        Constant.CustomerServiceRequestStatus.RE_PROCESSING ||
                      params.row.status ===
                        Constant.CustomerServiceRequestStatus.IN_TRANSIT))
                  )
                )
              }
              onStatusChange={(newStatus) =>
                handleUpdateStatus(
                  newStatus,
                  params.row?.status,
                  params.row?.id,
                  params.row?.requestType,
                  params.row?.requestNumber,
                  params.row?.companyId,
                  params.row?.userId,
                  params.row?.sellRequestFee,
                  params.row?.sellRequestFeeType,
                  params.row?.trackNumberValue,
                  params.row?.flowValue,
                  params.row?.companyName,
                  params.row?.destinationCompanyName
                )
              }
              allowedLabels={[]}
              serviceTypeId={params.row.serviceTypeId}
              isDestinationCompany = {params?.row?.isDestinationCompany}
              showTooltip={true}
            />

            {(params.row.status === "CANCELLED" ||
              params.row.status == "REJECTED") &&
              params.row.cancellationReason && (
                <Tooltip
                  title={`Reason: ${params.row?.cancellationReason}`}
                  arrow
                >
                  <StickyNote2Icon
                    className="note-icon cursor-pointer"
                    style={{ color: "gray", marginLeft: 3 }}
                  />
                </Tooltip>
              )}
          </div>
        </>
      ),
      renderHeader: (params) => (
        <>
          <div>
            <Typography
              variant="body2"
              sx={{ color: "#6F6F6F", fontSize: "14px" }}
            >
              {params.colDef.headerName}
            </Typography>

            <div className="position-relative" style={{ width: "200px" }}>
              <div
                className="form-control mb-1"
                style={{
                  cursor: "pointer",
                  borderBottomColor: "#D1D1D1",
                  marginTop: "4px",
                  background: "#fff",
                  padding: "5px",
                  overflowX: "hidden",
                  paddingRight: "16px",
                  textOverflow: "ellipsis",
                }}
                onClick={(event) => {
                  event.stopPropagation();
                  toggleDropdown();
                }}
                ref={buttonRef}
              >
                {filter.status?.length > 0
                  ? CommonService.formatStatus(filter.status).join(", ")
                  : "Select Status"}
                {/* <ExpandMore/> */}
                <img
                  src={ExpandMore}
                  className="position-absolute top-50 end-0 translate-middle"
                />
              </div>
              {/* <Form.Select
                                style={{ cursor: "pointer",borderBottomColor:"#D1D1D1",marginTop:"4px" }}
                                value={filter.status}
                                className="form-control mb-1"
                                onChange={(event) => handleFilterChange(event, "status")}
                                onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                            >
                                <option value="">Select Status</option>
                                <option value="PENDING_REVIEW">Pending Review</option>
                                <option value="ACCEPTED">Accepted</option>
                                <option value="REJECTED">Rejected</option>
                                <option value="CANCELLED">Cancelled</option>
                                <option value="CLOSED">Closed</option>
                                <option value="IN_PROGRESS">In Progress</option>
                                <option value="UNDER_REVIEW">Under Review</option>
                                <option value="UPLOADED">Uploaded</option>
                            </Form.Select> */}

              {/* Custom Dropdown */}
              {showDropdown && (
                <div
                  className="dropdown-menu show status-multiselect-dropdown"
                  onClick={(event) => event.stopPropagation()}
                  ref={divRef}
                >
                  {statusOptions.map((option) => (
                    <Form.Check
                      key={option.value}
                      id={`status-${option.value}`}
                      type="checkbox"
                      label={option.label}
                      value={option.value}
                      checked={
                        filter.status?.split(",").includes(option.value) ||
                        false
                      }
                      onChange={(event) => {
                        event.stopPropagation();
                        handleStatusChange(event, option.value, filter.status);
                      }}
                      className="cursor-pointer"
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      minWidth: 120,
      flex: 1,
      headerClassName: "table-header border-0 my-2 h-100",
      renderCell: (params: any) => {
        const isSuperAdminAndUser =
          params?.row?.roleName === "SUPER_ADMIN" && CommonService.isUser();

        const isReviewStage =
          params?.row?.requestType !== Constant.CustomerService.TASTING &&
          (params?.row?.status === Constant.CustomerServiceRequestStatus.PENDING_REVIEW ||
          params?.row?.status === Constant.CustomerServiceRequestStatus.UNDER_REVIEW ||
          params?.row?.status === Constant.CustomerServiceRequestStatus.SEND_TO_OWNER);

        const isTastingStage =
          !CommonService.isUser() && params?.row?.requestType === Constant.CustomerService.TASTING &&
          (params?.row?.status === Constant.CustomerServiceRequestStatus.SEND_TO_WAREHOUSE ||
          params?.row?.status === Constant.CustomerServiceRequestStatus.ADMIN_ACCEPTED_FOR_WAREHOUSE);


        const isSellRequestAllowed =
          params?.row?.requestType === Constant.CustomerService.SELL_REQUEST &&
          !["CANCELLED", "REJECTED", "DELETED", "UNPUBLISHED"].includes(
            params?.row?.status
          );

        const isWantedToBuyAllowed =
          params?.row?.requestType === Constant.CustomerService.WANTED_TO_BUY &&
          !["CANCELLED", "REJECTED", "DELETED","COMPLETED"].includes(
            params?.row?.status
          );

        const isCustomSampleAllowed =
          params?.row?.requestType === Constant.CustomerService.SAMPLE_REQUEST &&
          params?.row?.status === Constant.CustomerServiceRequestStatus.SEND_TO_OWNER;

        return (
          <>
            {(((params?.row?.requestType == Constant.CustomerService.SAMPLE_REQUEST || params?.row?.requestType !== Constant.CustomerService.TASTING ||
                params?.row?.requestType == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST) && 
                ['PENDING_REVIEW','UNDER_REVIEW','SEND_TO_OWNER'].includes(params?.row?.status)) || 
                ((!isSuperAdminAndUser || params?.row?.requestType == Constant.CustomerService.RE_CONTAINERIZATION || 
                  params?.row?.requestType == Constant.CustomerService.BARREL_HEAD_PAINTING || 
                  params?.row?.requestType !== Constant.CustomerService.TASTING) && isReviewStage || isTastingStage) || isSellRequestAllowed || isWantedToBuyAllowed) && (
              <div
                className="d-flex align-items-center gap-2 h-100"
                onClick={(e) => e.stopPropagation()}
              >
                {/* Edit Button */}
                {!(CommonService.isUser() && params?.row?.requestType === Constant.CustomerService.LOGISTIC) && (
                <Tooltip title="Edit" arrow>
                  <span>
                  <IconButton
                    aria-label="edit"
                    size="small"
                    onClick={() => handleEditServiceRequest(params?.row?.id)}
                    disabled={
                      !(params?.row?.requestType == Constant.CustomerService.SAMPLE_REQUEST || params?.row?.requestType == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST) &&
                      params?.row?.requestType !== Constant.CustomerService.SELL_REQUEST && params?.row?.requestType !== Constant.CustomerService.WANTED_TO_BUY &&
                      (isSuperAdminAndUser && params?.row?.requestType != Constant.CustomerService.RE_CONTAINERIZATION && params?.row?.requestType != Constant.CustomerService.BARREL_HEAD_PAINTING && params?.row?.requestType != Constant.CustomerService.TASTING) && 
                      !isCustomSampleAllowed // allow edit when custom sample + send_to_owner
                    }
                  >
                    <img
                      src={EditIcon}
                      className="cursor-pointer"
                      alt="EditIcon"
                    />
                  </IconButton>
                  </span>
                </Tooltip>
                )}

                {/* Delete Button (only for certain status/roles) */}
                {(((params?.row?.requestType == Constant.CustomerService.SAMPLE_REQUEST || params?.row?.requestType == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST) || (!isSuperAdminAndUser)) && ['PENDING_REVIEW','UNDER_REVIEW', 'SEND_TO_OWNER'].includes(params?.row?.status)) && (
                  <Tooltip title="Delete" arrow>
                    <span>
                    <IconButton
                      aria-label="delete"
                      size="small"
                      onClick={() => deleteServiceRequest(params?.row?.id)}
                      disabled={!(params?.row?.requestType == Constant.CustomerService.SAMPLE_REQUEST || params?.row?.requestType == Constant.CustomerService.CUSTOM_SAMPLE_REQUEST) && isSuperAdminAndUser}
                    >
                      <img
                        src={TrashIcon}
                        height={22}
                        width={22}
                        alt="DeleteIcon"
                      />
                    </IconButton>
                    </span>
                  </Tooltip>
                )}
              </div>
            )}
          </>
        );
      },
    },
  ];

    const onPaginationModelChange = (newPaginationModel) => {
      setPage(newPaginationModel.page);
      setPageSize(newPaginationModel.pageSize);
      loadAllServiceRequests(newPaginationModel.page, newPaginationModel.pageSize,filter, sortField, sortDirection);
    };
  
    const handleSortChange = (sortModel) => {
      if (sortModel.length > 0) {
          const newSortField = sortModel[0].field;
          const newSortDirection = sortModel[0].sort; // "asc" or "desc" directly from DataGrid
          
          setSortField(newSortField);
          setSortDirection(newSortDirection);
          loadAllServiceRequests(page, pageSize,filter, newSortField, newSortDirection);
      }
    };  

    return (
      <>
        <div
          className="usersList support-request-list-wrapper"
          style={{ paddingBottom: CommonService.isAdmin() ? 57 : "" }}
        >
          <div className="usersList__header--wrapper d-flex flex-wrap justify-content-between align-items-center gap-2">
            <div className="d-flex align-items-center gap-2 flex-wrap">
              {CommonService.isAdmin() && (
                <div className="back__button" onClick={() => history.goBack()}>
                  <IconButton
                    aria-label="ArrowBackIcon"
                    sx={{ backgroundColor: "#FFF" }}
                  >
                    <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
                  </IconButton>
                </div>
              )}
              {CommonService.isAdmin() && (
                <>
                  <Typography
                    variant="h1"
                    gutterBottom
                    sx={{
                      fontSize: "25px",
                      fontWeight: 700,
                      color: "#242424",
                      lineHeight: "22px",
                      marginBottom: "0px",
                    }}
                  >
                    Customer Service
                  </Typography>
                  <div className="divider mx-2"></div>
                </>
              )}
              <button
                className="primary-btn d-inline-flex"
                onClick={handleAddRequest}
              >
                <AddSharpIcon sx={{ mr: 0.5 }} />
                {state?.data === "Sell Request"
                  ? "Create Listing"
                  : "Submit New Request"}
              </button>
            </div>

            <div className="ms-auto d-flex gap-2 align-items-center">
              {/* <button className="primary-btn d-inline-flex me-1 ms-auto" onClick={handleAddRequest}>
              <AddSharpIcon sx={{ mr: 0.5 }} />
              Submit New Request
            </button> */}
              <div className="d-flex align-items-center">
                {/* <Tooltip title="Status Descriptions" arrow>
                  <IconButton 
                    onClick={() => setShowStatusFaq(true)}
                    sx={{ p: 0.5, mr: 1, color: "#496673" }}
                  >
                    <InfoOutlinedIcon style={{ fontSize: "20px" }} />
                  </IconButton>
                </Tooltip> */}
                {/* <button className="support-faq-btn" onClick={() => setShowStatusFaq(true)}> Click here for Status Description</button> */}
                <button className="support-faq-btn" onClick={handleShowFaq}>
                  Click here for FAQs and Tutorials
                </button>
              </div>
            </div>
          </div>
          <div className="user-table-container position-relative">
            {viewFaq && <SupportFaqPanel handleCloseFaq={handleCloseFaq} />}
            <div className="userTable">
              {/* {(isLoading) ? ( <><Skeleton
                      animation="wave"
                      variant="rounded" 
                      // height={550}
                      style={{height:"100%"}}
                    /></> ) : (<> */}
              <DataGrid
                rows={supportRequests}
                columns={columns}
                className="data-grid support-req--listing"
                initialState={{
                  pagination: {
                    paginationModel: { page, pageSize },
                  },
                }}
                pagination
                paginationModel={{ page, pageSize }}
                rowCount={totalCount}
                paginationMode="server"
                sortingMode="server"
                onSortModelChange={handleSortChange}
                onPaginationModelChange={onPaginationModelChange}
                pageSizeOptions={[10, 20, 50, 100]}
                disableRowSelectionOnClick={true}
                loading={isLoading}
                slots={{
                  loadingOverlay: DataGridLoader,
                }}
                onRowClick={handleRowClick}
                disableColumnResize
              />
              {/* </>)} */}
            </div>
          </div>
          {/* {showDropdown && (
              <div
                className="dropdown-menu show"
                style={{
                  position: "fixed",
                  top: `${position.top}px`,
                  left: `${position.left}px`,
                  zIndex: "1050", // High enough to appear above table
                  background: "#fff",
                  border: "1px solid #ccc",
                  padding: "5px",
                }}
                onClick={(event) => event.stopPropagation()}
                ref={divRef}
              >
                {statusOptions.map((option) => (
                  <Form.Check
                    key={option.value}
                    id={`status-${option.value}`}
                    type="checkbox"
                    label={option.label}
                    value={option.value}
                    checked={filter.status?.split(",").includes(option.value) || false}
                    onChange={(event) => {
                      event.stopPropagation();
                      handleStatusChange(event, option.value, filter.status);
                    }}
                    className="cursor-pointer"
                  />
                ))}
              </div>
            )} */}
        </div>

        <Modal
          show={show}
          onHide={handleClose}
          size={
            isSourceCompanyAccepted || isSourceCompanyRejected
              ? "lg"
              : undefined
          }
          className="modal__wd modal__wd--submitSellReq"
        >
          <Modal.Header className="justify-content-between align-items-start" closeButton={isSourceCompanyAccepted || isSourceCompanyRejected}>
            <div className="d-flex flex-column align-items-start">
            <Modal.Title>
              {" "}
              {isSourceCompanyAccepted || isSourceCompanyRejected
                ? "Legal Statement"
                : "Update Customer Service Request Status"}
            </Modal.Title>
            {isCancelled && (
              <p className="modal-text">
                Are you sure you want to cancel?{" "}
                {!isBeforeCancel ? "A cancellation charge may apply." : ""}
              </p>
            )}
            {isRejected && (
              <p className="modal-text">Are you sure you want to reject?</p>
            )}
            {isOwnershipTransferedAccepted && (
              <p className="modal-text">Please select transfer account owner</p>
            )}
            {isSellRequestAccepted && (
              <p className="modal-text">
                Please enter commission fee and fee type
              </p>
            )}
            {isInTransit && (
              <p className="modal-text">Please enter track number</p>
            )}
            {isInWarehouse && (
              <p className="modal-text">Please select warehouse</p>
            )}
            {isReopenConfirm && (
              <p className="modal-text">Are you sure you want to reopen this request?</p>
            )}
            {!isCancelled &&
              !isRejected &&
              !isSellRequestAccepted &&
              !isInTransit &&
              !isInWarehouse &&
              !isOwnershipTransferedAccepted &&
              !isSourceCompanyAccepted &&
              !isSourceCompanyRejected &&
              !isReopenConfirm && (
                <p className="modal-text">Close customer service request</p>
              )}
              </div>
              {(isSourceCompanyAccepted || isSourceCompanyRejected) &&
                <button
                  type="button"
                  className="btn-close p-0"
                  aria-label="Close"
                  onClick={() => handleClose()}>
                  {" "}
                  <CloseIcon />
                </button>
              }
          </Modal.Header>
          <Modal.Body>
            {isCancelled && (
              <div className="form__inner">
                <textarea
                  className={`form-control ${error ? "is_invalid" : ""}`}
                  aria-label="With textarea"
                  rows={8}
                  style={{ resize: "none" }}
                  value={reason}
                  onChange={handleReasonChange}
                  placeholder="Enter cancellation reason.."
                />

                {error && <div className="error-message">{error}</div>}
              </div>
            )}

            {isInWarehouse && (
              <div className="form__inner">
                <label className="modal-body__title mb-1">
                  Select Warehouse
                </label>
                <Select
                  className={`select-company-dropdown form-control w-100 multi-select-dropdown ${
                    warehouseError ? "is_invalid" : ""
                  }`}
                  options={warehouseUserList.map((user) => ({
                    value: user.userId,
                    label: user.userName,
                  }))}
                  onChange={handleWarehouseUserChange}
                  components={{
                    DropdownIndicator: () => <ExpandMoreRoundedIcon />,
                    IndicatorSeparator: () => null, // Remove the default separator
                  }}
                  isSearchable
                  placeholder="Select Warehouse"
                />
                {warehouseError && (
                  <div className="error-message">{warehouseError}</div>
                )}
              </div>
            )}

            {isOwnershipTransferedAccepted && (
              <div className="form__inner">
                <div className="d-flex align-items-start gap-3 justify-content-between">
                  <div>
                    <label className="modal-body__title">
                      Receiving Account Owner Name:
                    </label>
                    <p className="receiving-company-name">{receivingCompany}</p>
                  </div>
                  {/* {!isReceivingCompanyExist && receivingCompany != "" && (
                    <button
                      type="button"
                      className="primary-btn text-nowrap"
                      onClick={addCompany}
                    >
                      Create & Accept
                    </button> 
                  )}*/}
                </div>
                 {!isReceivingCompanyExist && receivingCompany != "" && (
                    <div style={{color: "red", fontSize: "13px", marginBottom: "12px"}}>
                      Account owner and associated user must be created in the system before accepting this ownership request.
                    </div>
                  )}
                <label
                  className="modal-body__title mb-1"
                  style={{ marginTop: "-34px" }}
                >
                  Select Transfer Account Owner
                </label>
                <Select
                  className={`select-company-dropdown form-control w-100 multi-select-dropdown ${transferCompanyError ? "is_invalid" : ""}`}
                  placeholder="Select Transfer Account Owner"
                  options={filteredCompanyOptions}
                  value={
                    filteredCompanyOptions.find(
                      (option) => option.value === selectedTransferCompany,
                    ) ||
                    filteredCompanyOptions.find(
                      (option) =>
                        option.label?.toLowerCase() ===
                        receivingCompany?.toLowerCase(),
                    ) ||
                    null // <-- shows placeholder if not found
                  }
                  onChange={handleTransferCompanyChange}
                  components={{
                    DropdownIndicator: () => <ExpandMoreRoundedIcon />,
                    IndicatorSeparator: () => null,
                  }}
                  isSearchable
                />
                {transferCompanyError && (
                  <div className="error-message">{transferCompanyError}</div>
                )}
              </div>
            )}

            {isRejected && (
              <div className="form__inner">
                <textarea
                  className={`form-control ${error ? "is_invalid" : ""}`}
                  aria-label="With textarea"
                  rows={8}
                  style={{ resize: "none" }}
                  value={reason}
                  onChange={handleReasonChange}
                  placeholder="Enter rejection reason.."
                />

                {error && <div className="error-message">{error}</div>}
              </div>
            )}

            {isSellRequestAccepted && (
              <>
                <div className="form__inner">
                  <label
                    style={{
                      color: "#333333",
                      fontWeight: "700",
                      marginBottom: "6px",
                    }}
                  >
                    Fee Type<span className="star-required text-danger">*</span>
                  </label>
                  <select
                    id="fee-type-dropdown"
                    value={sellRequestFeeType}
                    style={{ cursor: "pointer" }}
                    onChange={handleSellRequestFeeTypeChange}
                    className={`form-control no-spinner ${feeTypeError ? "is_invalid" : ""}`}
                  >
                    <option value="">Select Fee Type</option>
                    <option value="FLAT">Flat</option>
                    <option value="PERCENTAGE">Percentage</option>
                  </select>
                  {feeTypeError && (
                    <div className="error-message">{feeTypeError}</div>
                  )}
                </div>

                <div className="form__inner mt-2">
                  <label
                    style={{
                      color: "#333333",
                      fontWeight: "700",
                      marginBottom: "6px",
                    }}
                  >
                    Commission Fee ($) /Container
                    <span className="star-required text-danger">*</span>
                  </label>
                  <Form.Control
                    className={`form-control no-spinner ${feeError ? "is_invalid" : ""}`}
                    type="number"
                    value={sellRequestFee}
                    onChange={handleSellRequestFeeChange}
                    placeholder="Enter commission fee amount"
                  />
                  {feeError && <div className="error-message">{feeError}</div>}
                </div>
              </>
            )}

            {isInTransit && (
              <>
                <div className="form__inner">
                  <label
                    style={{
                      color: "#333333",
                      fontWeight: "700",
                      marginBottom: "6px",
                    }}
                  >
                    Track Number
                    <span className="star-required text-danger">*</span>
                  </label>
                  <Form.Control
                    className={`form-control ${trackNumberError ? "is_invalid" : ""}`}
                    type="text"
                    value={trackNumberValue}
                    onChange={handleInputTrackerNumber}
                    placeholder="Enter Tracking Number..."
                  />
                  {trackNumberError && (
                    <div className="error-message">{trackNumberError}</div>
                  )}
                </div>
              </>
            )}

            {isSourceCompanyAccepted && (
              <div className="source-company-modal">
                <div className="dynamic-content-wrapper">
                  <h3>Please review and accept the following legal statement.</h3>
                  {selectedCompanyRequest == CommonService.getCompanyId() ? (<p>
                    By confirming, you acknowledge that the selected lots and
                    their associated containers have been reviewed, validated, and
                    are eligible for transfer. You authorize the transfer of
                    ownership for the specified container from the <strong>{sourceCompanyName}</strong> to
                    the <strong>{destinationCompanyName}</strong> on the effective transfer date {CommonService.formatDateForSupportRequest(new Date().toString())}.
                  </p>) : (
                  <p>
                    By confirming, you acknowledge that the selected lots and their associated containers 
                    have been reviewed and validated for transfer. You accept the transfer of ownership
                    for the specified container from <strong>{sourceCompanyName}</strong>  to <strong>{destinationCompanyName}</strong> effective {CommonService.formatDateForSupportRequest(new Date().toString())}.
                  </p>
                  )}
                  <p>You understand and agree that:</p>

                  {selectedCompanyRequest == CommonService.getCompanyId() ? (<ul>
                    <li>
                      All information submitted in this request is accurate and complete to the best of your knowledge.
                    </li>
                    <li>
                      The container selected for transfer meet the required compliance, warehouse, and industry standards.
                    </li>
                    <li>
                      The transfer will result in a formal and binding update to the ownership records.
                    </li>
                    <li>
                      Once approved, the transfer cannot be reversed without initiating a new request and obtaining the necessary approvals.
                    </li>
                  </ul>) : (
                  <ul>
                    <li>
                      The information provided in this transfer request is accurate and complete to the best of your knowledge.
                    </li>
                    <li>
                      The container being transferred meet all required compliance, warehouse, and industry standards.
                    </li>
                    <li>
                      This transfer will result in a formal and binding update to the ownership records, recognizing <strong>{destinationCompanyName}</strong> as the new owner.
                    </li>
                    <li>
                      Once approved, the transfer cannot be reversed without submitting a new request and obtaining the necessary approvals.
                    </li>
                  </ul>
                  )}
                </div>

                <div className="form__inner">
                  <label
                    style={{
                      color: "#333333",
                      fontWeight: "700",
                      marginBottom: "6px",
                    }}
                  >
                    Enter Your Full Name
                    <span className="star-required text-danger">*</span>
                  </label>
                  <Form.Control
                    className={`form-control ${ownershipNameError ? "is_invalid" : ""}`}
                    type="text"
                    value={ownershipName}
                    onChange={handleInputOwnershipName}
                    placeholder=" Enter Your Full Name"
                  />
                  {ownershipNameError && (
                    <div className="error-message">{ownershipNameError}</div>
                  )}
                  <p className="customer-info-text">
                    This transfer is at the direction of customer and any agreement to transfer property is between customer and new customer for which White Dog is not liable.
                  </p>

                  {/* ✅ Agree Checkbox */}
                  <div className="form-check mt-3">
                    <input
                      type="checkbox"
                      id="agreeConsent"
                      className="form-check-input"
                      checked={isAgreed}
                      onChange={(e) => {
                        setAgreeError("");
                        setIsAgreed(e.target.checked);
                      }}
                    />

                    <label htmlFor="agreeConsent" className="form-check-label">
                      By clicking <strong>Agree</strong>, you confirm your
                      consent by providing full legal name, which will be
                      treated as your electronic signature.
                    </label>
                  </div>

                  {agreeError && (
                    <div className="error-message">{agreeError}</div>
                  )}
                </div>
              </div>
            )}

            {isSourceCompanyRejected && (
              <div className="source-rejected-wrapper">
                <h3>Are you sure you want to disagree?</h3>

                <p>This will close the request from your end.</p>

                <p className="mb-3">
                  If you want to reopen the request mind later, you may need to
                  contact an administrator or submit a new one.
                </p>
                <div className="form__inner">
                  <div className="form-check accept-form-check">
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <input
                        type="radio"
                        id="goBack"
                        name="decision"
                        className="form-check-input"
                        onChange={() => handleClose()}
                      />

                      <label htmlFor="goBack" className="form-check-label">
                        No, Go Back
                      </label>
                    </div>
                    <div className="info-msg">
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.00195 0C9.31566 0 12.002 2.68629 12.002 6C12.002 9.31371 9.31566 12 6.00195 12C2.6883 11.9999 0.00195312 9.31367 0.00195312 6C0.00195333 2.68633 2.6883 6.10937e-05 6.00195 0ZM4.98145 5.15625L4.91992 5.44238L5.25879 5.50391C5.47834 5.55664 5.52196 5.63581 5.47363 5.85547L4.91992 8.45703C4.77518 9.12886 4.99944 9.44516 5.52637 9.44531C5.93496 9.44531 6.40959 9.25625 6.625 8.99707L6.69141 8.68555C6.542 8.81726 6.32172 8.87012 6.17676 8.87012C5.97053 8.86994 5.89557 8.7244 5.94824 8.46973L6.7002 4.94141L4.98145 5.15625ZM6.00195 2.625C5.58779 2.62506 5.25195 2.96082 5.25195 3.375C5.25195 3.78918 5.58779 4.12494 6.00195 4.125C6.41617 4.125 6.75195 3.78921 6.75195 3.375C6.75195 2.96079 6.41617 2.625 6.00195 2.625Z"
                          fill="#0A3622"
                        />
                      </svg>
                      Choose if you want to review the legal terms again.
                    </div>
                  </div>

                  {/* YES - Close Request */}
                  <div className="form-check reject-form-check">
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <input
                        type="radio"
                        id="closeRequest"
                        name="decision"
                        className="form-check-input"
                        onChange={() => changeCustomerServiceRequestStatus()}
                      />

                      <label
                        htmlFor="closeRequest"
                        className="form-check-label"
                      >
                        Yes, Close Request
                      </label>
                    </div>
                    <div className="info-msg">
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.00195 0C9.31566 0 12.002 2.68629 12.002 6C12.002 9.31371 9.31566 12 6.00195 12C2.6883 11.9999 0.00195312 9.31367 0.00195312 6C0.00195333 2.68633 2.6883 6.10937e-05 6.00195 0ZM4.98145 5.15625L4.91992 5.44238L5.25879 5.50391C5.47834 5.55664 5.52196 5.63581 5.47363 5.85547L4.91992 8.45703C4.77518 9.12886 4.99944 9.44516 5.52637 9.44531C5.93496 9.44531 6.40959 9.25625 6.625 8.99707L6.69141 8.68555C6.542 8.81726 6.32172 8.87012 6.17676 8.87012C5.97053 8.86994 5.89557 8.7244 5.94824 8.46973L6.7002 4.94141L4.98145 5.15625ZM6.00195 2.625C5.58779 2.62506 5.25195 2.96082 5.25195 3.375C5.25195 3.78918 5.58779 4.12494 6.00195 4.125C6.41617 4.125 6.75195 3.78921 6.75195 3.375C6.75195 2.96079 6.41617 2.625 6.00195 2.625Z"
                          fill="#0A3622"
                        />
                      </svg>
                      Choose if you want to close the request.
                    </div>
                  </div>
                </div>
              </div>
            )}

            {isReopenConfirm && (
              <div className="form__inner">
                <p className="mb-0">
                  This action will move the request back to an active state.
                </p>
              </div>
            )}

            {!isCancelled &&
              !isRejected &&
              !isSellRequestAccepted &&
              !isInTransit &&
              !isInWarehouse &&
              !isOwnershipTransferedAccepted &&
              !isSourceCompanyAccepted &&
              !isSourceCompanyRejected &&
              !isReopenConfirm &&
              serviceRequestUpdateStatus.current.serviceName !== Constant.CustomerService.PRIVATE_SELL && (
                <div className="form__inner">
                  <label
                    style={{
                      color: " #333333",
                      fontWeight: "700",
                      marginBottom: "6px",
                    }}
                  >
                    Time Spent (hours)
                    <span className="star-required text-danger">*</span>
                  </label>
                  <Form.Control
                    className={`form-control no-spinner ${error ? "is_invalid" : ""}`}
                    type="number"
                    value={spendHour}
                    onChange={handleSpendHourChange}
                    placeholder="Enter hours"
                  />
                  {error && <div className="error-message">{error}</div>}
                </div>
              )}
          </Modal.Body>
          <Modal.Footer className="justify-content-center">
            {!isSourceCompanyRejected && (
              <div className="btn-group d-flex align-items-center gap-3 justify-content-center flex-wrap">
                {/* <div className="col-6 ps-0"> */}
                <button
                  className="secondary-btn"
                  onClick={handleClose}
                  disabled={isLoading}
                  style={{ minWidth: "190px" }}
                >
                  Cancel
                </button>
                {/* </div>
        
                    <div className="col-6 pe-0"> */}
                <button
                  className="primary-btn"
                  style={{ minWidth: "190px" }}
                  //onClick={isSellRequestFeeUpdated ? updateSellRequestFeeDetails : changeCustomerServiceRequestStatus}
                  onClick={
                    isInTransit
                      ? updateSampleRequestDetails
                      : isSellRequestFeeUpdated
                        ? updateSellRequestFeeDetails
                        : isOwnershipTransferedAccepted
                          ? updateTransferCompanyDetails
                          : changeCustomerServiceRequestStatus
                  }
                  disabled={isLoading}
                >
                  {isLoading && <Spinner />}{" "}
                  {isInTransit || isInWarehouse
                    ? "Yes"
                    : isSellRequestFeeUpdated
                      ? "Update"
                      : isCancelled
                        ? "Cancel Request"
                        : isRejected
                          ? "Reject Request"
                          : isReopenConfirm
                            ? "Reopen Request"
                          : isSellRequestAccepted ||
                              isOwnershipTransferedAccepted
                            ? "Accept"
                            : isSourceCompanyAccepted
                              ? "Agree"
                              : "Close Request"}
                </button>
                {/* </div> */}
              </div>
            )}
          </Modal.Footer>
        </Modal>
        <StatusFaqModal show={showStatusFaq} handleClose={() => setShowStatusFaq(false)} />
      </>
    );
};

export default SupportRequest;
